import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useModalStore } from '@features/modal'
import OrderAddressModal from '@features/order-form/ui/OrderAddressModal/OrderAddressModal'
import { useAddressStore } from '@features/shipping-methods'

import Button from '@shared/ui/button'
import Checkbox from '@shared/ui/checkbox'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from '@shared/ui/form'
import Input from '@shared/ui/input'
import Textarea from '@shared/ui/text-area'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'



export default function DeliveryForm () {
  const { control } = useFormContext()
  const { t: o } = useTranslation('order')
  const { t: c } = useTranslation('common')
  const { selectedAddress } = useAddressStore()
  const { openModal } = useModalStore()

  return (
    <Wrapper className={styles.root__wrapper}>
      <h3 className={styles.root__title}>{c('delivery')}</h3>
      <div className={styles.root}>
        <div className={styles.form}>
          <FormField
            control={control}
            name="address"
            render={({ field }) => (
              <FormItem className={styles.form__item}>
                <FormControl>
                  <Input
                    disabled
                    theme="grey"
                    {...field}
                    placeholder={o('form.address.placeholder')}
                  />
                </FormControl>
                <Button
                  onClick={() => {
                    openModal('orderAddress', <OrderAddressModal />, {
                      title: o('modal_address_title'),
                      classes: {
                        content: styles.modal,
                      },
                    })
                  }}
                  theme="secondary"
                >
                  {c('change')}
                </Button>
                <FormDescription>
                  <span>{o('form.address.description')}</span>
                </FormDescription>
              </FormItem>
            )}
          />

          <div className={styles.form__flex}>
            {[
              {
                name: 'apartment',
                placeholder: o('form.apartment'),
                value: selectedAddress?.address_appartments,
              },
              {
                name: 'floor',
                placeholder: o('form.floor'),
                value: selectedAddress?.address_floor,
              },
              {
                name: 'entrance',
                placeholder: o('form.entrance'),
                value: selectedAddress?.address_porch,
              },
              {
                name: 'intercom',
                placeholder: o('form.intercom'),
                value: selectedAddress?.address_intercom,
              },
            ]
              .filter(({ value }) => value)
              .map(({ name, placeholder, value }) => (
                <p key={name}>
                  {placeholder}: <span>{value}</span>
                </p>
              ))}
          </div>
          <div className={styles.form__grid}>
            <FormField
              control={control}
              name="comment"
              render={({ field }) => (
                <FormItem className={styles.form__comment}>
                  <FormControl>
                    <Textarea
                      {...field}
                      placeholder={o('form.comment-delivery')}
                      className={styles.textarea}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <div className={styles.form__options}>
            {[
              { name: 'noIntercomCall', label: o('form.noIntercomCall') },
              { name: 'leaveAtDoor', label: o('form.leaveAtDoor') },
            ].map(({ name, label }) => (
              <FormField
                key={name}
                control={control}
                name={name as string}
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <Checkbox
                        checked={!!field.value}
                        onChange={field.onChange}
                        label={label}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
            ))}
          </div>
          {/* <FormField
            control={control}
            name="isPrivateHouse"
            render={({ field }) => (
              <FormItem className={styles.form__switch}>
                <FormControl>
                  <Switch onChange={field.onChange} checked={field.value} />
                </FormControl>
                <FormDescription>{o("form.private-house")}</FormDescription>
              </FormItem>
            )}
          /> */}
        </div>
      </div>
    </Wrapper>
  )
}
